/// <amd-module name="TFS/TenantPicker/Service/TenantPickerService" />
import * as React from "react";

import { TenantPickerPanelComponent } from "TFS/TenantPicker/Components/TenantPanel/TenantPickerPanel";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";

export interface ITenantPickerPanel extends IVssService {
    show: () => void;
}
class TenantPickerPanel extends VssService implements ITenantPickerPanel {
    public show(): void {
        const layoutService = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutService.renderCallout((onDismiss: () => void) => {
            // Have a local function for closing the panel cleaning up our state.
            const onPanelDismiss = (): void => {
                onDismiss();
            };

            // Render the tenant picker panel
            return React.createElement(TenantPickerPanelComponent, { onDismiss: onPanelDismiss }, null);
        });
    }
}

Services.add("ITenantPickerPanel", { serviceFactory: TenantPickerPanel });
